import {
  useMemo
} from "react"

import {
  useStyle
} from "@/classify"
import GalleryAd from "./ad"
import defaultClasses from "./gallery.module.css"
import GalleryItem from "./item"
import GalleryItemShimmer from "./item.shimmer"


const Gallery = (props) => {
  const {
    items, ads 
  } = props

  const itemsClone = items.concat([])

  const classes = useStyle(defaultClasses, props.classes)

  const storeConfig = {
    "storeConfig": {
      "__typename": "StoreConfig",
      "store_code": process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
      "product_url_suffix": ".html",
      "magento_wishlist_general_is_enabled": "1",
      "base_url": "https://www.hisea.com/"
    }
  }

  const galleryItems = useMemo(
    () => itemsClone.map((item, index) => {
      if (item === null) {
        return <GalleryItemShimmer key={index} />
      }

      if (item.__typename === "Advertisement") {
        return <GalleryAd key={item.id} item={item} />
      }
 
      return (
        <GalleryItem
          key={item.id}
          item={item}
        />
      )
                
    }),
    [itemsClone]
  )

  return (
    <div className={classes.root} aria-live='polite' aria-busy='false'>
      <div className={classes.items}>{galleryItems}</div>
    </div>
  )
}

export default Gallery
